module.exports = __webpack_public_path__ + "img/icon-pubg.7ab60cb.png";